import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { Dropdown } from '../containers';
import { Icon } from '../ui_elements';
import customIcons from '../styles/icons';
import { fonts } from '../styles/theme';
import {
  mobileItemColor,
  mobileItemHoverColor,
  mobileNavHeight,
  navAccentColor,
  navDropdownStyles,
  navItemColor,
  navItemHoverColor,
} from './theme-nav';

const IconWrapper = styled('div')`
  text-align: center;
  width: 40px;
  height: 36px;
  margin: 7px 10px;
  border-radius: 12px;
  &:hover {
    cursor: pointer;
  }
  @media screen and (max-width: 1000px) {
    text-align: left;
    padding: 0 10px;
    margin: 0;
    width: auto;
    height: ${mobileNavHeight};
    color: ${mobileItemColor};
    &::after {
      /* adds dropdown arrow - mobile */
      ${fonts.icons}
      content: '${customIcons['angle-down']}';
      position: absolute;
      top: 0;
      right: 10px;
      line-height: 30px;
      color: inherit;
      margin-left: 3px;
      font-size: 18px;
    }
    &:hover {
      color: ${mobileItemHoverColor};
    }
  } ;
`;

const StyledIcon = styled(Icon)`
  color: ${navItemColor};
  &::before {
    font-size: 24px;
    line-height: 40px;
    width: auto;
    margin-right: 0;
  }
  @media screen and (max-width: 1000px) {
    color: ${mobileItemColor};
    &::before {
      content: 'Create';
      font-family: ${fonts.sans.family};
      font-size: ${fonts.sans.size.normal};
      font-weight: ${fonts.sans.weight.bold};
      line-height: ${mobileNavHeight};
      width: auto;
      color: inherit;
    }
    &:hover {
      color: ${mobileItemHoverColor};
    }
  }
`;

export const CreateDropdown = styled(Dropdown)`
  ${IconWrapper} {
    background: ${navAccentColor};
  }
  &:hover {
    ${StyledIcon} {
      color: ${navItemHoverColor};
    }
  }
  ${navDropdownStyles};
  @media screen and (max-width: 1000px) {
    order: ${(props) => props.mobileorder};
    flex-grow: 0;
    ${IconWrapper} {
      background: none;
    }
    &:hover {
      ${StyledIcon} {
        color: ${mobileItemHoverColor};
      }
    }
  }

  margin-top: unset;
`;

const CreateBtn = () => (
  <IconWrapper>
    <StyledIcon type="plus" name="styled-icon" />
  </IconWrapper>
);

const NavLinksCreate = ({ links, mobileorder }) => (
  <CreateDropdown Trigger={CreateBtn} links={links} mobileorder={mobileorder} title="Create" />
);

const dropdownLinkShape = PropTypes.shape({
  name: PropTypes.string,
  path: PropTypes.string,
});

NavLinksCreate.defaultProps = {
  mobileorder: '',
};

NavLinksCreate.propTypes = {
  mobileorder: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.oneOfType([dropdownLinkShape, PropTypes.arrayOf(dropdownLinkShape)])
  ).isRequired,
};

export default NavLinksCreate;
